// Regla financiera aprobada por el dueño: una factura emitida tiene 15 días
// para pagarse SIN considerarse en mora; la mora cuenta desde el vencimiento
// (emisión + 15 días). Fuente de verdad única para backend y frontend.
import dayjs from 'dayjs';

/** Días desde la emisión de una factura durante los cuales NO se considera en mora. */
export const DIAS_GRACIA_FACTURA = 15;

/**
 * Fecha de vencimiento de una legacy invoice: fecha de emisión +
 * DIAS_GRACIA_FACTURA días. New invoice rows may provide their persisted due
 * date explicitly (period end), preserving the legacy derivation for old rows.
 * All results are normalized to the start of the day.
 */
export function fechaVencimientoFactura(
  fechaEmision: Date | string | null,
  fechaVencimiento?: Date | string | null,
): Date | null {
  if (fechaVencimiento !== undefined) {
    if (fechaVencimiento === null) return null;
    const explicitDueDate = dayjs(fechaVencimiento);
    return explicitDueDate.isValid() ? explicitDueDate.startOf('day').toDate() : null;
  }
  if (!fechaEmision) return null;
  const emision = dayjs(fechaEmision);
  if (!emision.isValid()) return null;
  return emision.startOf('day').add(DIAS_GRACIA_FACTURA, 'day').toDate();
}

/**
 * Días de mora de una factura: 0 mientras hoy no supere el vencimiento
 * (dentro de la gracia, incluido el propio día del vencimiento); días enteros
 * desde el vencimiento cuando hoy ya lo superó (Math.max(0, diff)). A persisted
 * due date can be supplied as the third argument for period-end invoices.
 * Devuelve null cuando la entrada es null o una fecha inválida.
 */
export function diasEnMora(
  fechaEmision: Date | string | null,
  hoy: Date = new Date(),
  fechaVencimiento?: Date | string | null,
): number | null {
  const vencimiento = fechaVencimientoFactura(fechaEmision, fechaVencimiento);
  if (!vencimiento) return null;
  return Math.max(dayjs(hoy).startOf('day').diff(dayjs(vencimiento).startOf('day'), 'day'), 0);
}
